/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_ViewInputs */

const en_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const de_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

const fr_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

const es_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const it_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza`)
};

const nl_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijken`)
};

const pl_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyświetl`)
};

const fi_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä`)
};

const da_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis`)
};

const sv_interview_prepare_view = /** @type {(inputs: Interview_Prepare_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Interview_Prepare_ViewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_view = /** @type {((inputs?: Interview_Prepare_ViewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_ViewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_view(inputs)
	if (locale === "fr") return fr_interview_prepare_view(inputs)
	if (locale === "es") return es_interview_prepare_view(inputs)
	if (locale === "it") return it_interview_prepare_view(inputs)
	if (locale === "nl") return nl_interview_prepare_view(inputs)
	if (locale === "pl") return pl_interview_prepare_view(inputs)
	if (locale === "fi") return fi_interview_prepare_view(inputs)
	if (locale === "da") return da_interview_prepare_view(inputs)
	if (locale === "sv") return sv_interview_prepare_view(inputs)
	return en_interview_prepare_view(inputs)
});